module.exports = __webpack_public_path__ + "img/ST.7fc7895f.svg";